import type { Length } from '@gitbook/api-client';

/**
 * Take a number or length object (value and unit) and return a string representation of the length, e.g. "50%" or "250px".
 */
export function lengthToString(value: Length) {
    if (typeof value === 'number') {
        return `${value}`; // Convert number to pixel value
    }
    const { value: length, unit } = value;
    return `${length}${unit}`; // Convert object to string like "50%" or "250px"
}
